import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isUuid(value: string) {
  return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value);
}

export function generateUuidV4Regex({
  paramName = "uuid",
  prefix = "",
  suffix = "",
  allowTrailing = false,
}: {
  paramName?: string;
  prefix?: string;
  suffix?: string;
  allowTrailing?: boolean;
}): RegExp {
  const endAnchor = allowTrailing ? "" : "$";
  return new RegExp(
    `^${prefix}/(?<${paramName}>[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})${suffix}${endAnchor}`,
  );
}

/**
 * Formats a name for safe display in UI components.
 * Removes or escapes problematic characters and truncates long names for better UX.
 */
export function formatNameForDisplay(name: string, maxLength = 40): string {
  if (!name || name.trim().length === 0) {
    return "";
  }

  let safeName = name
    .trim() // Remove leading and trailing whitespace
    .replace(/"/g, "'") // Replace double quotes with single quotes
    .replace(/[^\x20-\x7E\u00A0-\uFFFF]/g, "") // Keep only printable ASCII and Unicode characters
    .replace(/\s+/g, " ") // Normalize whitespace (multiple spaces become single space)
    .trim(); // Remove any leading/trailing spaces again after replacements

  if (safeName.length > maxLength) {
    safeName = `${safeName.substring(0, maxLength).trim()}...`;
  }

  return safeName;
}
